<script>
import dragula from 'dragula'
import 'dragula/dist/dragula.css'

export default {
  props: {
    dragHandleClass: {
      type: String,
      default: 'dragula-handle'
    },

    dragContainerClass: {
      type: String,
      default: 'dragula-container'
    }
  },

  mounted() {
    this.createDraggableInstance()
  },

  methods: {
    getContainers() {
      return Array.from(this.$refs.containerRef.querySelectorAll(`.${this.dragContainerClass}`))
    },

    createDraggableInstance() {
      this.dragulaInstance = dragula([this.$refs.containerRef, ...this.getContainers()], {
        direction: 'vertical',
        revertOnSpill: true,
        invalid: (_, handle) => {
          if (handle.classList.contains(this.dragHandleClass)) {
            return false
          }

          let parent = handle.parentNode

          while (parent) {
            if (!parent.classList) {
              return true
            }

            if (parent.classList.contains(this.dragHandleClass)) {
              return false
            }

            parent = parent.parentNode
          }

          return true
        }
      })
        .on('drag', (el, source) => {
          document.body.classList.add('dragula-dragging')

          this.$emit('drag', { el, source })
        })
        .on('dragend', (el) => {
          document.body.classList.remove('dragula-dragging')

          this.$emit('dragend', { el })
        })
        .on('drop', (el, target, source, sibling) => {
          this.$emit('drop', {
            el, target, source, sibling
          })
        })
        .on('cancel', (el, container, source) => {
          this.$emit('cancel', { el, container, source })
        })
        .on('remove', (el, container, source) => {
          this.$emit('remove', { el, container, source })
        })
        .on('shadow', (el, container, source) => {
          this.$emit('shadow', { el, container, source })
        })
        .on('over', (el, container, source) => {
          this.$emit('over', { el, container, source })
        })
        .on('out', (el, container, source) => {
          this.$emit('out', { el, container, source })
        })
        .on('cloned', (clone, original, type) => {
          this.$emit('cloned', { clone, original, type })
        })
    },

    destroyDraggableInstance() {
      if (this.dragulaInstance) {
        this.dragulaInstance.destroy()
      }
    },

    update() {
      this.destroyDraggableInstance()
      this.createDraggableInstance()
    }
  }
}
</script>

<template>
  <div ref="containerRef">
    <slot
      :drag-handle-class="dragHandleClass"
      :drag-container-class="dragContainerClass"
    />
  </div>
</template>

<style lang="scss">
body.dragula-dragging {
  &,
  & * {
    cursor: grabbing !important;
  }
}
</style>
